/**
 * Lightweight Markdown detection for block cards.
 *
 * Decides whether a block's plain-text content contains Markdown syntax so
 * the card can render it via `marked` instead of showing the raw symbols.
 * Detection only affects display — it never rewrites stored text, so a false
 * positive (or negative) is harmless.
 */

const MD_PATTERNS = [
  /^\s{0,3}#{1,6}\s/,             // heading
  /^\s*([-*+]|\d+\.)\s+/,         // unordered / ordered list
  /^\s*>\s/,                       // blockquote
  /`{1,3}/,                        // inline / fenced code
  /!?\[[^\]]*\]\([^)]*\)/,        // link or image
  /\*\*|__|~~/,                    // bold / strikethrough
  /^\s*(\*{3,}|-{3,}|_{3,})\s*$/, // horizontal rule
  /^\s*\|.*\|\s*$/,                // table row
];

/**
 * True if any line of `content` matches a Markdown pattern.
 *
 * Single `*` / `_` (italic) is intentionally excluded to avoid false
 * positives like `2 * 3 = 6` or `file_name.txt`.
 *
 * @param {string} content - Block text (may be empty)
 * @returns {boolean}
 */
export function isMarkdownBlock(content) {
  if (!content) return false;
  return content.split('\n').some((line) => MD_PATTERNS.some((re) => re.test(line)));
}
